var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYellowSweater = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 259 169",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M194.47 155.148a4.503 4.503 0 0 1-4.503 4.502h-75.513c-2.486 0-10.397.036-12.856-2.992-1.802-24.701-5.306-74.686-5.306-89.748 0-2.288 1.89-4.144 4.219-4.144h70.751c2.33 0 4.22 1.856 4.22 4.144l18.988 88.238Z",
  fill: "#BFC6CD"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M200.354 155.148a4.503 4.503 0 0 1-4.503 4.502h-75.513c-2.486 0-10.384 6.026-10.384 3.54 0 0-8.147-76.006-8.147-96.28 0-2.288 1.889-4.144 4.219-4.144h70.751c2.33 0 4.22 1.856 4.22 4.144l19.359 88.238h-.002Z",
  fill: "#DBE0E2"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M156.535 22.808c-7.204-2.77-17.646-2.503-21.258 9.69-2.53 8.548-6.126 23.467-.85 26.057 2.336 1.147 11.773 1.414 11.773 1.414l-4.668 15.694 18.205-2.519-.663-16.18s21.205-25.035-2.539-34.156Z",
  fill: "#A3ABB7"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "m141.967 22.722 9.253 17.848c2.437-3.487 5.331-2.148 6.55 1.062 1.499 3.946-3.274 6.586-3.01 7.887.27 1.3 3.359 7.188 4.316 7.444.955.256 20.551-5.962 14.557-28.251-2.764-10.272-19.263-15.741-31.663-5.99h-.003Z",
  fill: "#313844"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M156.061 7.677c-2.079 5.728.204 10.601 5.414 12.493 5.213 1.892 8.948-.987 11.028-6.715 2.082-5.726.891-11.028-4.319-12.92-5.21-1.892-10.043 1.41-12.123 7.139v.003Z",
  fill: "#313844"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M210.74 141.569c-1.502-5.905-18.248-54.743-22.195-60.133-3.488-4.763-22.232-11.347-28.954-13.588-4.308 3.69-12.235 3.897-15.888.264-5.931 2.115-20.067 6.751-24.088 10.18-9.001 7.676-29.018 39.907-34.899 58.89-3.11 10.041 13.495 22.102 26.677 28.1 0 0-.3-.044-.669 3.036l77.942-1.344c6.032-2.734 27.455-4.266 22.074-25.405Z",
  fill: "#FFBE0D"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M122.607 141.03c.881.555 3.131 5.31 3.466 6.157.479 1.196-1.031 3.05-2.671 1.276-1.301-1.411-2.632-2.819-2.632-2.819s2.621 4.763 3.193 5.654c.573.894.872 2.492.223 3.028-.979.806-2.214.286-2.965-.731-.751-1.021-3.801-4.491-3.801-4.491l3.518 6.462s.632 1.532-.46 2.233c-1.444.924-2.319-.742-2.869-1.6-.55-.858-3.57-4.733-3.57-4.733l-.459.344s3.042 3.38 3.408 4.403c.366 1.025-.677 1.74-1.912 1.284-.828-.305-3.716-2.956-3.716-2.956s-1.615-.176-2.3-.413c-.688-.239-1.345-.737-1.711-1.229-.366-.492.091-4.612 2.575-6.785 2.481-2.175 4.31-3.25 6.654-3.979 2.343-.729 4.805-1.873 6.027-1.105h.002Z",
  fill: "#A3ABB7"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M44.92 90.764c-.026 0 10.199-13.321 10.199-18.587 0-3.985-1.755-8.022-5.221-9.128-2.844-.907-9.066-.784-11.946 0-3.51.954-5.221 5.143-5.221 9.128 0 5.282 10.122 18.587 10.15 18.587-.039 0-10.15 13.258-10.15 18.541 0 3.985 1.71 8.17 5.22 9.125 2.883.783 9.103.907 11.947 0 3.466-1.106 5.22-5.14 5.22-9.125 0-5.266-8.375-16.401-10.199-18.54Z",
  fill: "#ECF0F0"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M37.952 118.432c2.882.784 9.102.908 11.946 0 2.536-.808 4.156-3.187 4.841-5.967-4.698-2.967-8.95-6.465-10.816-6.465-2.118 0-6.313 3.396-10.873 6.264.644 2.91 2.264 5.451 4.902 6.168ZM44.92 90.764s1.394-1.873 3.143-4.436c1.13-1.655-11.798-5.349-10.277-2.95 2.534 3.995 5.081 7.386 5.095 7.386h2.038Z",
  fill: "#FF5A2D"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M44.196 107.19c-.075 1.81-.584.165-.605.017.09-.361-.248-15.288-.71-16.443.313-.289 1.824-.294 2.038 0-.487.586-.886 15.631-.723 16.426Z",
  fill: "#FF5A2D"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.9
}, /*#__PURE__*/React.createElement("path", {
  d: "M78.47 142.262H23.425v21.596H78.47v-21.596Z",
  fill: "#DBE0E2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.663 135.321v-.042H19.618v6.983h55.045v-6.941Z",
  fill: "#BFC6CD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.47 118.98H23.425v16.299H78.47V118.98Z",
  fill: "#DBE0E2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.47 120.635H23.425v1.139H78.47v-1.139Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.47 125.228H23.425v4.455H78.47v-4.455Z",
  fill: "#BFC6CD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.47 148.182H23.425v2.258H78.47v-2.258Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.47 159.155H23.425v1.059H78.47v-1.059Z",
  fill: "#BFC6CD"
}))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M64.972 142.262H9.927v21.596h55.045v-21.596Z",
  fill: "#DBE0E2"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M61.162 135.321v-.042H6.12v6.983h55.042v-6.941Z",
  fill: "#BFC6CD"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M64.972 118.98H9.927v16.299h55.045V118.98Z",
  fill: "#DBE0E2"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M64.972 120.635H9.927v1.139h55.045v-1.139Z",
  fill: "#fff"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M64.972 125.228H9.927v4.455h55.045v-4.455Z",
  fill: "#BFC6CD"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M64.972 148.182H9.927v2.258h55.045v-2.258Z",
  fill: "#fff"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M64.972 159.155H9.927v1.059h55.045v-1.059Z",
  fill: "#BFC6CD"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "M209.12 163.858h-80.849l19.511-51.957h80.852l-19.514 51.957Z",
  fill: "#DBE0E2"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "M133.137 163.858H99.639v-1.474l33.498-1.474v2.948Z",
  fill: "#DBE0E2"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  d: "M185.186 139.294c-1.521 3.6-5.064 5.919-7.913 5.176-2.85-.74-3.926-4.257-2.402-7.857 1.521-3.6 5.064-5.918 7.914-5.175 2.85.739 3.925 4.257 2.401 7.856Z",
  fill: "#fff"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  d: "M251.663 160.17c-3.947 0-7.157-3.209-7.157-7.155 0-4.164 3.675-4.164 5.647-4.164.245 0 .498 0 .754.003.519.005 1.07.005 1.589 0 .256 0 .507-.003.749-.003 1.29 0 2.635.044 3.691.588 1.249.641 1.882 1.846 1.882 3.578 0 3.947-3.21 7.156-7.155 7.156v-.003Zm-1.507-8.976c-3.034 0-3.307.473-3.307 1.823a4.82 4.82 0 0 0 4.814 4.813 4.82 4.82 0 0 0 4.814-4.813c0-1.457-.38-1.823-3.23-1.823-.236 0-.481 0-.729.003-.53.005-1.094.005-1.628 0-.25 0-.495-.003-.734-.003Z",
  fill: "#477E96"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "M251.856 160.272a3.877 3.877 0 0 1-3.879 3.877h-10.599a3.877 3.877 0 0 1-3.878-3.877v-14.606h18.356v14.606Z",
  fill: "#477E96"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M242.088 157.093a2.912 2.912 0 0 1-2.913 2.912 2.912 2.912 0 0 1-2.913-2.912v-11.149h5.823v11.149h.003Z",
  fill: "#A5D4DE"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  d: "M252.865 145.903a.99.99 0 0 1-.99.99h-18.301a.99.99 0 1 1 0-1.98h18.301a.99.99 0 0 1 .99.99Z",
  fill: "#477E96"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  d: "M259 164.001H0v5h259v-5Z",
  fill: "#1C222E"
})));
export default SvgYellowSweater;